import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface FulfillmentDataCountInterface {
  partnerCodes?: any
  fulfillmentOrderTypes?: any
  fromDate?: any
  toDate?: any
}

export const useGetFulfillmentDataCount = () => {
  const mutate = useMutation(
    ({
      partnerCodes,
      fulfillmentOrderTypes,
      fromDate,
      toDate,
    }: FulfillmentDataCountInterface) => {
      return postAPI(`MWDashboard/GetFulfillmentDetails`, {
        partnerCodes: partnerCodes || [],
        fulfillmentOrderTypes: fulfillmentOrderTypes || [],
        fromDate: fromDate || '',
        toDate: toDate || '',
      })
    },
  )

  return mutate
}

export default useGetFulfillmentDataCount
